import { Seo } from "components/Seo";
import { AccountState } from "context/AccountContext";
import { Company } from "models/Company";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { companyService } from "services/Services";
import { UrlPath } from "utility/routes";

interface InputValues {
  companyName: string;
  orgNr: string;
  companyId: string;
}

const defaultValue: InputValues = {
  companyName: '',
  orgNr: '',
  companyId: ''
}

type addCompanyInput = string;

const AddCompany = () => {
  const navigate = useNavigate();
  const [inputValues, setInputValues] = useState<InputValues>(defaultValue);
  const [currentCompany, setCurrentCompany] = useState<Company>();
  const [companyOptions, setCompanyOptions] = useState<Company[]>([]);
  const [comanyLoading, setCompanyLoading] = useState(false);
  const [disableBtn, setDisableBtn] = useState(true);
  const [disableInput, setDisableInput] = useState(false);
  //const [isChecked, setIsCecked] = useState(false);
  const { stateAccount } = AccountState();

  const orgNumberQuery = async (org: addCompanyInput) => {
    setCurrentCompany(undefined);
    setCompanyOptions([]);
    const response = await companyService.getCompanyByOrgNumber(org);

    if (response?.companies !== null) {
      setCompanyOptions(response?.companies || []);
      const company = response?.companies?.find(x => x);
      if (company !== undefined) {

        if (response?.companies?.length === 1) {
          setCurrentCompany(company)
          setInputValues((prev) => ({
            ...inputValues,
            orgNr: org,
            companyName: company.name as string,
            companyId: company.id as string
          }));
          setDisableBtn(false);
        }
        else {
          setDisableBtn(true);
        }

      }
      setDisableInput(false);
    }
  }

  const inputHandler = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    if (value.length <= 9) {
      setInputValues((prev) => ({
        ...inputValues,
        [name]: value
      }))
    }

    if (value.length === 9) {
      setDisableInput(true);
      await orgNumberQuery(value);
    }

    if (inputValues.companyName !== '' && value.length < 9) {
      setDisableBtn(true);
      setInputValues((prev) => ({
        ...inputValues,
        [name]: value,
        companyName: ''
      }))
    }
  }

  const radioChangeHandler = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    const newCurrentCompany = companyOptions.find(x => x.id === value);
    setCurrentCompany(newCurrentCompany);
    setDisableBtn(false);

  }

  // const checkHandler = () => {
  //   const checkbox = document.getElementById("bekreftTill");
  //   setIsCecked(!isChecked)
  //   if(!isChecked) {
  //     checkbox?.classList.remove("is-invalid");
  //     checkbox?.classList.add("is-valid");
  //   } else {
  //     checkbox?.classList.remove("is-valid");
  //     checkbox?.classList.add("is-invalid");
  //   }
  // }

  const onSubmit = async (e: React.SyntheticEvent) => {
    e.preventDefault();

    if (currentCompany !== undefined) {
      setCompanyLoading(true);
      stateAccount.addCompany(currentCompany);
    }
    //e.stopPropagation();
    // if(isChecked && currentCompany !== undefined) {
    //   console.log('onsubmit', currentCompany)
    //   //setCompanyLoading(true);
    //   //stateAccount.addCompany(currentCompany);
    // } else {
    //   //document.getElementById("addCompanyForm")?.classList.add('was-validated');
    //   if(!isChecked) {

    //   }
    // }

  }
  useEffect(() => {
    if (comanyLoading && currentCompany !== undefined) {
      navigate(UrlPath.Account.Company + "/" + currentCompany.id);
    }
  }, [stateAccount.companies, comanyLoading, navigate, currentCompany])

  return (
    <><Seo title="Legg til bedrift" />
      <div className="card">
        <div className="card-body">
          <form id="addCompanyForm" className="needs-validation" onSubmit={onSubmit} noValidate>
            <h1 className="h3">Velg din bedrift</h1>
            <div className="mb-3">
              <label htmlFor="orgNr" className="form-label">
                Organisasjonsnummer
              </label>
              <input type="number" disabled={disableInput} onChange={inputHandler} className="form-control" id="orgNr" name="orgNr" value={inputValues.orgNr} maxLength={9} required />
            </div>
            {companyOptions.length > 19 ? <p className="mt-4 mb-4 fw-medium">Vi har mange treff på dette organisasjonsnummeret og viser et begrenset utvalg, <a href="https://kundeservice.1881.no/hc/no/requests/new" target="_blank">kontakt kundeservice</a> hvis du trenger hjelp til å gjøre endringer.</p> : null}
            {companyOptions.length > 1 ?
              companyOptions.map((company, index) => {
                return (
                  <div className="form-check mb-3" key={company.id}>
                    <input className="form-check-input" type="radio" name="flexRadioDefault" id={"flexRadioDefault" + company.id} onChange={radioChangeHandler} value={company.id}></input>
                    <label className="form-check-label" htmlFor={"flexRadioDefault" + company.id}>
                      {company.name}. {company.location.streetName} {company.location.houseNumber}{company.location.houseLetter}{company.location.streetName !== null ? "," : ""} {company.location.postalCode} {company.location.postalArea}
                      <br></br> <span className="text-secondary">{company.legalName !== null && company.name !== company.legalName ? "Juridisk navn: " + company.legalName : null}</span>
                    </label>
                  </div>)
              }) :
              <div className="mb-3">
                {currentCompany !== undefined ? <p className="mb-0">{currentCompany.name}. {currentCompany.location.streetName} {currentCompany.location.houseNumber}{currentCompany.location.houseLetter}{currentCompany.location.streetName !== null ? "," : ""} {currentCompany.location.postalCode} {currentCompany.location.postalArea} {currentCompany.legalName !== null && currentCompany.name !== currentCompany.legalName ? "Juridisk navn: " + currentCompany.legalName : null}</p> : null}
              </div>
            }


            {/* <div className="form-check mb-4">
            <input className="form-check-input" type="checkbox" value="" id="bekreftTill" checked={isChecked} onChange={checkHandler} required />
            <label className="form-check-label" htmlFor="bekreftTill"> Jeg har eierskap eller tillatelse på vegne av bedriften til å endre opplysninger. </label>
            <div className="invalid-feedback">Må bekreftes</div>
          </div> */}
            <p className="mt-4">
              <button type="submit" disabled={disableBtn} className="btn btn-primary">
                Gå videre
              </button>
              <button
                type="button"
                className="btn btn-outline-primary ms-2"
                onClick={() => navigate(-1)}
              >
                Avbryt
              </button>
            </p>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddCompany;
